module.exports = __webpack_public_path__ + "static/media/plumbing.99b24305.svg";